import Element from '../models/Element';
import { SUBSTANCE_CATEGORIES as C } from '../constants/effects';

// [atomicNumber, symbol, name, atomicMass, category]
const PERIODIC_TABLE_ROWS = [
  [1, 'H', 'Hydrogen', 1.008, C.NONMETAL],
  [2, 'He', 'Helium', 4.0026, C.NOBLE_GAS],
  [3, 'Li', 'Lithium', 6.94, C.ALKALI_METAL],
  [4, 'Be', 'Beryllium', 9.0122, C.ALKALINE_EARTH_METAL],
  [5, 'B', 'Boron', 10.81, C.METALLOID],
  [6, 'C', 'Carbon', 12.011, C.NONMETAL],
  [7, 'N', 'Nitrogen', 14.007, C.NONMETAL],
  [8, 'O', 'Oxygen', 15.999, C.NONMETAL],
  [9, 'F', 'Fluorine', 18.998, C.HALOGEN],
  [10, 'Ne', 'Neon', 20.18, C.NOBLE_GAS],
  [11, 'Na', 'Sodium', 22.99, C.ALKALI_METAL],
  [12, 'Mg', 'Magnesium', 24.305, C.ALKALINE_EARTH_METAL],
  [13, 'Al', 'Aluminium', 26.982, C.POST_TRANSITION_METAL],
  [14, 'Si', 'Silicon', 28.085, C.METALLOID],
  [15, 'P', 'Phosphorus', 30.974, C.NONMETAL],
  [16, 'S', 'Sulfur', 32.06, C.NONMETAL],
  [17, 'Cl', 'Chlorine', 35.45, C.HALOGEN],
  [18, 'Ar', 'Argon', 39.948, C.NOBLE_GAS],
  [19, 'K', 'Potassium', 39.098, C.ALKALI_METAL],
  [20, 'Ca', 'Calcium', 40.078, C.ALKALINE_EARTH_METAL],
  [21, 'Sc', 'Scandium', 44.956, C.TRANSITION_METAL],
  [22, 'Ti', 'Titanium', 47.867, C.TRANSITION_METAL],
  [23, 'V', 'Vanadium', 50.942, C.TRANSITION_METAL],
  [24, 'Cr', 'Chromium', 51.996, C.TRANSITION_METAL],
  [25, 'Mn', 'Manganese', 54.938, C.TRANSITION_METAL],
  [26, 'Fe', 'Iron', 55.845, C.TRANSITION_METAL],
  [27, 'Co', 'Cobalt', 58.933, C.TRANSITION_METAL],
  [28, 'Ni', 'Nickel', 58.693, C.TRANSITION_METAL],
  [29, 'Cu', 'Copper', 63.546, C.TRANSITION_METAL],
  [30, 'Zn', 'Zinc', 65.38, C.TRANSITION_METAL],
  [31, 'Ga', 'Gallium', 69.723, C.POST_TRANSITION_METAL],
  [32, 'Ge', 'Germanium', 72.63, C.METALLOID],
  [33, 'As', 'Arsenic', 74.922, C.METALLOID],
  [34, 'Se', 'Selenium', 78.971, C.NONMETAL],
  [35, 'Br', 'Bromine', 79.904, C.HALOGEN],
  [36, 'Kr', 'Krypton', 83.798, C.NOBLE_GAS],
  [37, 'Rb', 'Rubidium', 85.468, C.ALKALI_METAL],
  [38, 'Sr', 'Strontium', 87.62, C.ALKALINE_EARTH_METAL],
  [39, 'Y', 'Yttrium', 88.906, C.TRANSITION_METAL],
  [40, 'Zr', 'Zirconium', 91.224, C.TRANSITION_METAL],
  [41, 'Nb', 'Niobium', 92.906, C.TRANSITION_METAL],
  [42, 'Mo', 'Molybdenum', 95.95, C.TRANSITION_METAL],
  [43, 'Tc', 'Technetium', 98, C.TRANSITION_METAL],
  [44, 'Ru', 'Ruthenium', 101.07, C.TRANSITION_METAL],
  [45, 'Rh', 'Rhodium', 102.91, C.TRANSITION_METAL],
  [46, 'Pd', 'Palladium', 106.42, C.TRANSITION_METAL],
  [47, 'Ag', 'Silver', 107.87, C.TRANSITION_METAL],
  [48, 'Cd', 'Cadmium', 112.41, C.TRANSITION_METAL],
  [49, 'In', 'Indium', 114.82, C.POST_TRANSITION_METAL],
  [50, 'Sn', 'Tin', 118.71, C.POST_TRANSITION_METAL],
  [51, 'Sb', 'Antimony', 121.76, C.METALLOID],
  [52, 'Te', 'Tellurium', 127.6, C.METALLOID],
  [53, 'I', 'Iodine', 126.9, C.HALOGEN],
  [54, 'Xe', 'Xenon', 131.29, C.NOBLE_GAS],
  [55, 'Cs', 'Caesium', 132.91, C.ALKALI_METAL],
  [56, 'Ba', 'Barium', 137.33, C.ALKALINE_EARTH_METAL],
  [57, 'La', 'Lanthanum', 138.91, C.LANTHANIDE],
  [58, 'Ce', 'Cerium', 140.12, C.LANTHANIDE],
  [59, 'Pr', 'Praseodymium', 140.91, C.LANTHANIDE],
  [60, 'Nd', 'Neodymium', 144.24, C.LANTHANIDE],
  [61, 'Pm', 'Promethium', 145, C.LANTHANIDE],
  [62, 'Sm', 'Samarium', 150.36, C.LANTHANIDE],
  [63, 'Eu', 'Europium', 151.96, C.LANTHANIDE],
  [64, 'Gd', 'Gadolinium', 157.25, C.LANTHANIDE],
  [65, 'Tb', 'Terbium', 158.93, C.LANTHANIDE],
  [66, 'Dy', 'Dysprosium', 162.5, C.LANTHANIDE],
  [67, 'Ho', 'Holmium', 164.93, C.LANTHANIDE],
  [68, 'Er', 'Erbium', 167.26, C.LANTHANIDE],
  [69, 'Tm', 'Thulium', 168.93, C.LANTHANIDE],
  [70, 'Yb', 'Ytterbium', 173.05, C.LANTHANIDE],
  [71, 'Lu', 'Lutetium', 174.97, C.LANTHANIDE],
  [72, 'Hf', 'Hafnium', 178.49, C.TRANSITION_METAL],
  [73, 'Ta', 'Tantalum', 180.95, C.TRANSITION_METAL],
  [74, 'W', 'Tungsten', 183.84, C.TRANSITION_METAL],
  [75, 'Re', 'Rhenium', 186.21, C.TRANSITION_METAL],
  [76, 'Os', 'Osmium', 190.23, C.TRANSITION_METAL],
  [77, 'Ir', 'Iridium', 192.22, C.TRANSITION_METAL],
  [78, 'Pt', 'Platinum', 195.08, C.TRANSITION_METAL],
  [79, 'Au', 'Gold', 196.97, C.TRANSITION_METAL],
  [80, 'Hg', 'Mercury', 200.59, C.TRANSITION_METAL],
  [81, 'Tl', 'Thallium', 204.38, C.POST_TRANSITION_METAL],
  [82, 'Pb', 'Lead', 207.2, C.POST_TRANSITION_METAL],
  [83, 'Bi', 'Bismuth', 208.98, C.POST_TRANSITION_METAL],
  [84, 'Po', 'Polonium', 209, C.POST_TRANSITION_METAL],
  [85, 'At', 'Astatine', 210, C.HALOGEN],
  [86, 'Rn', 'Radon', 222, C.NOBLE_GAS],
  [87, 'Fr', 'Francium', 223, C.ALKALI_METAL],
  [88, 'Ra', 'Radium', 226, C.ALKALINE_EARTH_METAL],
  [89, 'Ac', 'Actinium', 227, C.ACTINIDE],
  [90, 'Th', 'Thorium', 232.04, C.ACTINIDE],
  [91, 'Pa', 'Protactinium', 231.04, C.ACTINIDE],
  [92, 'U', 'Uranium', 238.03, C.ACTINIDE],
  [93, 'Np', 'Neptunium', 237, C.ACTINIDE],
  [94, 'Pu', 'Plutonium', 244, C.ACTINIDE],
  [95, 'Am', 'Americium', 243, C.ACTINIDE],
  [96, 'Cm', 'Curium', 247, C.ACTINIDE],
  [97, 'Bk', 'Berkelium', 247, C.ACTINIDE],
  [98, 'Cf', 'Californium', 251, C.ACTINIDE],
  [99, 'Es', 'Einsteinium', 252, C.ACTINIDE],
  [100, 'Fm', 'Fermium', 257, C.ACTINIDE],
  [101, 'Md', 'Mendelevium', 258, C.ACTINIDE],
  [102, 'No', 'Nobelium', 259, C.ACTINIDE],
  [103, 'Lr', 'Lawrencium', 266, C.ACTINIDE],
  [104, 'Rf', 'Rutherfordium', 267, C.TRANSITION_METAL],
  [105, 'Db', 'Dubnium', 268, C.TRANSITION_METAL],
  [106, 'Sg', 'Seaborgium', 269, C.TRANSITION_METAL],
  [107, 'Bh', 'Bohrium', 270, C.TRANSITION_METAL],
  [108, 'Hs', 'Hassium', 277, C.TRANSITION_METAL],
  [109, 'Mt', 'Meitnerium', 278, C.TRANSITION_METAL],
  [110, 'Ds', 'Darmstadtium', 281, C.TRANSITION_METAL],
  [111, 'Rg', 'Roentgenium', 282, C.TRANSITION_METAL],
  [112, 'Cn', 'Copernicium', 285, C.TRANSITION_METAL],
  [113, 'Nh', 'Nihonium', 286, C.POST_TRANSITION_METAL],
  [114, 'Fl', 'Flerovium', 289, C.POST_TRANSITION_METAL],
  [115, 'Mc', 'Moscovium', 290, C.POST_TRANSITION_METAL],
  [116, 'Lv', 'Livermorium', 293, C.POST_TRANSITION_METAL],
  [117, 'Ts', 'Tennessine', 294, C.HALOGEN],
  [118, 'Og', 'Oganesson', 294, C.NOBLE_GAS],
];

// Kid-friendly one-liners. Elements without one get a generated description from Element.
const KID_DESCRIPTIONS = {
  H: 'The lightest element in the universe. Stars are mostly made of it!',
  He: 'The gas that makes balloons float and voices squeaky.',
  Li: 'A soft metal that powers the batteries in phones and tablets.',
  Be: 'A light, strong metal used in space telescopes.',
  B: 'Found in borax, used to make slime!',
  C: 'Found in pencils, diamonds and every living thing, including you!',
  N: 'Most of the air you breathe is nitrogen.',
  O: 'The gas we need to breathe. Fire needs it too!',
  F: 'Its cousin fluoride is in toothpaste to keep teeth strong.',
  Ne: 'Makes bright glowing signs light up red-orange.',
  Na: 'A metal so soft you could cut it with a butter knife.',
  Mg: 'Burns with a super bright white light, used in fireworks.',
  Al: 'Light and shiny. Soda cans and foil are made of it.',
  Si: 'Sand is made of it, and so are computer chips!',
  P: 'Used on the side of matchboxes to help matches light.',
  S: 'A yellow element that smells like rotten eggs when it reacts.',
  Cl: 'A green-yellow gas used to keep swimming pools clean.',
  Ar: 'A lazy gas that fills old-style light bulbs.',
  K: 'Bananas have lots of it! As a pure metal it is very jumpy.',
  Ca: 'Makes your bones and teeth strong.',
  Ti: 'A super strong, light metal used in planes and bikes.',
  Cr: 'Makes things shiny, like car bumpers and taps.',
  Fe: 'A strong metal used to make steel for bridges and buildings.',
  Co: 'Gives glass and paint a deep blue colour.',
  Ni: 'Found in coins and magnets.',
  Cu: 'An orange-brown metal inside electric wires.',
  Zn: 'Coats steel to stop it rusting, and is in some sunscreens.',
  Ga: 'A metal that can melt in your hand!',
  Br: 'One of only two elements that is a liquid at room temperature.',
  Kr: 'Superman\'s kryptonite is made up, but krypton gas is real!',
  Sr: 'Makes fireworks glow bright red.',
  Ag: 'A shiny metal used in jewellery and medals.',
  Sn: 'Tin cans are really steel with a thin tin coat.',
  I: 'Used to clean cuts and scrapes. It turns purple as a gas.',
  Xe: 'Makes very bright car headlights.',
  Ba: 'Makes fireworks glow green.',
  Nd: 'Makes the strongest magnets in the world.',
  W: 'Has the highest melting point of any metal.',
  Pt: 'A precious metal that helps clean car exhaust.',
  Au: 'A precious metal that almost never reacts, so it stays shiny forever.',
  Hg: 'The only metal that is liquid at room temperature.',
  Pb: 'A very heavy, soft metal. Old water pipes were made of it, but it is poisonous.',
  Rn: 'A radioactive gas that can seep out of the ground.',
  U: 'Radioactive! Used as fuel in nuclear power stations.',
  Pu: 'Radioactive! It powered the Curiosity rover on Mars.',
  Es: 'Named after the scientist Albert Einstein.',
  Og: 'The heaviest element ever made. It lasts less than a thousandth of a second!',
};

export const ELEMENTS = PERIODIC_TABLE_ROWS.map(
  ([atomicNumber, symbol, name, atomicMass, category]) =>
    new Element({ atomicNumber, symbol, name, atomicMass, category, description: KID_DESCRIPTIONS[symbol] })
);
